import { defineMessages } from "react-intl";
const messages = defineMessages({
    topRankingTitle: {
        id: "app.aiDiscoverability.topRanking.title",
        defaultMessage: "Top Ranking",
    },
    mostCitedBy: {
        id: "app.aiDiscoverability.topRanking.mostCitedBy",
        defaultMessage: "Most cited by:",
    },
    bestPerforming: {
        id: "app.aiDiscoverability.topRanking.bestPerforming",
        defaultMessage: "Best performing: {features}",
    },
    topRankedAriaLabel: {
        id: "app.aiDiscoverability.topRanking.topRankedAriaLabel",
        defaultMessage: "Top ranked",
    },
    scoreNotAvailable: {
        id: "app.aiDiscoverability.topRanking.scoreNotAvailable",
        defaultMessage: "N/A",
    },
    youRankLabel: {
        id: "app.aiDiscoverability.topRanking.youRankLabel",
        defaultMessage: "You - #{rank}",
    },
    youBadgeLabel: {
        id: "app.aiDiscoverability.topRanking.youBadgeLabel",
        defaultMessage: "You",
    },
    minLabel: {
        id: "app.aiDiscoverability.topRanking.minLabel",
        defaultMessage: "(min)",
    },
    maxLabel: {
        id: "app.aiDiscoverability.topRanking.maxLabel",
        defaultMessage: "(max)",
    },
});
export default messages;
